import axios from "axios";
import store from "@/store";

export default function interceptorsSetup() {
  axios.interceptors.request.use(
    function(config) {
      if (store.state.statHideLoading == true) {
        store.state.showLoading = false;
      } else {
        store.state.showLoading = true;
      }
      return config;
    },
    function(error) {
      store.state.showLoading = false;
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    function(response) {
      store.state.showLoading = false;
      return response;
    },
    function(error) {
      store.state.showLoading = false;
      return Promise.reject(error);
    }
  );
}
